import { useEffect, useState } from 'react';
import { Save, Plus, Trash2, Loader2, Sparkles } from 'lucide-react';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminListingPromotion() {
  const { authFetch } = useAdminAuth();
  const [tiers, setTiers] = useState([]);
  const [currency, setCurrency] = useState('eur');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      const r = await authFetch(`${API}/admin/listing-promotion-settings`);
      if (r.ok) {
        const d = await r.json();
        setTiers(d.tiers || []);
        setCurrency(d.currency || 'eur');
      }
      setLoading(false);
    })();
  }, [authFetch]);

  function setTier(i, key, val) {
    setTiers(prev => prev.map((t, idx) => idx === i ? { ...t, [key]: val } : t));
  }
  function addTier() { setTiers(prev => [...prev, { days: 7, price_eur: 5, label: '7 dana' }]); }
  function removeTier(i) { setTiers(prev => prev.filter((_, idx) => idx !== i)); }

  async function save() {
    setSaving(true);
    try {
      const payload = {
        tiers: tiers.map(t => ({ days: Number(t.days) || 0, price_eur: Number(t.price_eur) || 0, label: t.label || '' })),
        currency,
      };
      const r = await authFetch(`${API}/admin/listing-promotion-settings`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!r.ok) throw new Error('save failed');
      toast.success('Postavke spremljene');
    } catch (e) { toast.error('Spremanje neuspješno'); } finally { setSaving(false); }
  }

  if (loading) return <div className="p-8 text-zinc-500"><Loader2 className="animate-spin inline mr-2" /> Učitavam…</div>;

  return (
    <div className="p-4 md:p-6 max-w-3xl" data-testid="admin-listing-promotion">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles className="text-amber-500" size={18} />
        <h1 className="text-2xl font-bold text-white">Promocija oglasa (Istakni)</h1>
      </div>
      <p className="text-sm text-zinc-400 mb-6">Cijene paketa kojima korisnici mogu istaknuti svoje oglase u Oglasniku i Poslu. Svaki paket podiže oglas na vrh popisa za određeni broj dana.</p>

      <div className="space-y-3 bg-zinc-900 border border-zinc-700 rounded-lg p-4">
        <div className="grid grid-cols-12 gap-2 text-[11px] uppercase text-zinc-500 px-2">
          <div className="col-span-3">Naziv</div>
          <div className="col-span-3">Trajanje (dani)</div>
          <div className="col-span-4">Cijena (€)</div>
          <div className="col-span-2"></div>
        </div>
        {tiers.map((t, i) => (
          <div key={i} className="grid grid-cols-12 gap-2 items-center" data-testid={`promo-tier-row-${i}`}>
            <input className="col-span-3 bg-zinc-950 border border-zinc-700 rounded px-3 py-2 text-sm text-zinc-200" value={t.label || ''} onChange={e => setTier(i, 'label', e.target.value)} placeholder="npr. 7 dana" />
            <input type="number" min="1" className="col-span-3 bg-zinc-950 border border-zinc-700 rounded px-3 py-2 text-sm text-zinc-200" value={t.days} onChange={e => setTier(i, 'days', e.target.value)} />
            <input type="number" min="0" step="0.01" className="col-span-4 bg-zinc-950 border border-zinc-700 rounded px-3 py-2 text-sm text-zinc-200" value={t.price_eur} onChange={e => setTier(i, 'price_eur', e.target.value)} />
            <button onClick={() => removeTier(i)} className="col-span-2 text-red-400 hover:text-red-300" title="Ukloni paket"><Trash2 size={14} /></button>
          </div>
        ))}
        <button onClick={addTier} className="inline-flex items-center gap-1 px-3 py-1.5 bg-zinc-800 hover:bg-zinc-700 text-sm rounded text-zinc-200" data-testid="promo-tier-add">
          <Plus size={14} /> Dodaj paket
        </button>
      </div>

      <div className="mt-5">
        <label className="flex items-center gap-3 text-sm text-zinc-300">
          Valuta:
          <select value={currency} onChange={e => setCurrency(e.target.value)} className="bg-zinc-900 border border-zinc-700 rounded px-3 py-1.5 text-sm">
            <option value="eur">EUR</option>
            <option value="usd">USD</option>
          </select>
        </label>
      </div>

      <div className="pt-5">
        <button onClick={save} disabled={saving} className="inline-flex items-center gap-1.5 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white text-sm rounded font-medium disabled:opacity-50" data-testid="promo-save">
          {saving ? <Loader2 className="animate-spin" size={14} /> : <Save size={14} />} Spremi
        </button>
      </div>
    </div>
  );
}
